import Model, { executeMutation, GqlError, ID, Integer, IsoDateTime, JsonArray, JsonObject, MODEL_LEVEL } from 'src/models/model'
import Modifier from 'src/models/modifier-set/Modifier'

export default class ModifierSet extends Model {
  static name = 'ModifierSet'

  static isConfiguration = true

  static duplicatable = true

  static paginate = true

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Concession]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      action: {
        type: String,
        input: true
      },
      modifiers: {
        type: [Modifier],
        default: () => ([]),
        reference: true
      },
      modifierIds: {
        type: [ID],
        computed () {
          if (this.modifiers) return _.map(this.modifiers.data, 'id')

          if (!this.data) return []

          return this.data.modifierIds
        },
        encode (data) {
          if (this.modifiers) {
            data.modifierIds = _.map(this.modifiers.data, 'id')
          } else {
            data.modifierIds = this.data.modifierIds
          }
        },
        default: () => ([])
      },
      name: {
        type: String,
        required: true,
        translatable: true
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      availableOnline: {
        type: Boolean,
        default: true
      },
      multiselect: {
        type: Boolean,
        default: true
      },
      printingOptions: {
        type: JsonObject,
        default: () => ({
          print_name: true
        })
      },
      archivedAt: {
        type: IsoDateTime,
        output: true
      },
      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      },
      receiveLibraryUpdates: {
        type: Boolean,
        excludeFromDefault: true
      },
      libraryChildSiteIds: {
        type: [ID],
        output: true,
        excludeFromDefault: true
      },
      libraryDescendantSites: {
        type: JsonArray,
        output: true,
        excludeFromDefault: true
      }
    }

    this.computed = {
      activeModifiers () {
        return _.filter(this.modifiers?.data, { active: true, toBeDeleted: false })
      },
      onlineModifiers () {
        return _.filter(this.activeModifiers, 'availableOnline')
      },
      isAvailableOnline () {
        return this.availableOnline && !_.isEmpty(this.onlineModifiers)
      },
      description () {
        return _.map(this.activeModifiers, 'description').join(', ')
      }
    }

    this.mutations = {
      updateModifierOrder: {
        arguments: {
          modifierSetId: {
            type: ID,
            required: true
          },
          modifierIds: {
            type: [ID],
            required: true
          }
        },
        results: {
          success: Boolean,
          errors: [GqlError]
        }
      }
    }
  }

  async updateModifierOrder (modifierIds) {
    const results = await executeMutation(
      'updateModifierOrder',
      {
        modifierSetId: this.id,
        modifierIds
      },
      {
        success: true,
        errors: {
          structure: {
            code: true,
            description: true
          }
        }
      }
    )

    return results
  }
}
